<template>
  <th 
    :class="cssClass"
    @click="sortRows(column.sortable ? column.id : false)">
    {{ column.label }}
  </th>
</template>

<script>
export default {
  name: 'ColumnHeader',
  props: {
    active: {
      type: Boolean,
      required: true
    },
    column: {
      type: Object,
      required: true
    }
  },
  methods: {
    sortRows (index) {
      if (index !== false) {
        this.$emit('sort', index)
      }
    }
  },
  computed: {
    cssClass () {
      let arr = []
      if (this.column.sortable == true) {
        arr.push('sortable')
      }
      if (this.active) {
        arr.push('sort-active')
        arr.push('sort-' + this.sorting.dir.toLowerCase())
      }

      if (this.column.css_class) {
        arr.push(this.column.css_class)
      }

      if (this.column.hidden) {
        arr.push('hide')
      }

      return (arr.length ? arr.join(' ') : '')
    },
    sorting () {
      return this.$store.getters.params.sorting
    }
  }
}
</script>
